import React, { useMemo, useState } from 'react';
import { Brand } from './Brand.jsx';

export function HomeScreen({ initialCode = '', initialName = '', connected, busy, onCreate, onJoin }) {
  const [name, setName] = useState(initialName);
  const [code, setCode] = useState(initialCode);
  const cleanCode = useMemo(() => code.replace(/\D/g, '').slice(0, 6), [code]);
  const canSubmit = connected && !busy && name.trim().length > 0;

  return (
    <main className="home-shell">
      <section className="hero-card">
        <div className="hero-intro">
          <Brand />
          <h1>Jeder Wurf zählt.</h1>
          <p className="lead">Ein schnelles Roll-&-Write-Spiel für 2–5 Personen – direkt im Browser, ohne Konto und mit privaten Räumen.</p>
        </div>

        <div className="hero-actions">
          <label className="field">
            <span>Dein Name</span>
            <input
              value={name}
              onChange={(event) => setName(event.target.value.slice(0, 24))}
              placeholder="Sebastian"
              autoComplete="nickname"
              maxLength={24}
            />
          </label>

          <button className="button button--primary button--large" disabled={!canSubmit} onClick={() => onCreate(name)}>
            Neuen Raum erstellen
          </button>

          <div className="divider"><span>oder beitreten</span></div>

          <div className="join-grid">
            <label className="field">
              <span>Raumcode</span>
              <input
                className="code-input"
                value={cleanCode}
                onChange={(event) => setCode(event.target.value)}
                placeholder="123456"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="one-time-code"
                maxLength={6}
              />
            </label>
            <button className="button button--secondary" disabled={!canSubmit || cleanCode.length !== 6} onClick={() => onJoin(cleanCode, name, false)}>
              Mitspielen
            </button>
            <button className="button button--ghost" disabled={!canSubmit || cleanCode.length !== 6} onClick={() => onJoin(cleanCode, name, true)}>
              Zuschauen
            </button>
          </div>

          <div className={`connection-pill ${connected ? 'is-online' : 'is-offline'}`}>
            <span aria-hidden="true" /> {connected ? 'Server verbunden' : 'Verbindung wird hergestellt …'}
          </div>
        </div>
      </section>

      <section className="feature-row" aria-label="Funktionen">
        <article><strong>Private Lobby</strong><span>Code, Link oder QR</span></article>
        <article><strong>Live-Multiplayer</strong><span>Mit Wiederverbindung</span></article>
        <article><strong>Handy & Desktop</strong><span>Als PWA installierbar</span></article>
      </section>
    </main>
  );
}
